import { Component, Vue, Prop } from 'vue-property-decorator'
import { Articulo } from '@/types/types'

@Component
export default class ArticuloList extends Vue {
  @Prop()
  items!: Articulo[]

  @Prop()
  loading!: boolean
}
